import { SelectRecordTag } from "./SelectRecordTag.js";
import "react";
import { jsx } from "react/jsx-runtime";
import { Field, useFormikContext } from "formik";
//#region src/modules/Records/shared/FormikSelectRecordTag.tsx
var FormikSelectRecordTag = (props) => {
	const form = useFormikContext();
	const mode = props.returnValueMode || "option";
	return /* @__PURE__ */ jsx(Field, {
		name: props.name,
		children: ({ field, meta }) => {
			return /* @__PURE__ */ jsx(SelectRecordTag, {
				...props,
				error: meta.touched && meta.error,
				valid: meta.touched && meta.value && !meta.error,
				onChangeOptions: (option) => {
					if (mode === "option") props.name && form.setFieldValue(props.name, option);
				},
				onChangeValue: (value) => {
					if (mode === "value") props.name && form.setFieldValue(props.name, value);
				},
				...field,
				onChange: null
			});
		}
	});
};
//#endregion
export { FormikSelectRecordTag };

//# sourceMappingURL=FormikSelectRecordTag.js.map